import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UilabMatIconModule } from '@uilab/ng-mat-components';
import { CssVariableSnippetComponent } from '../../../../shared/components/css-variable-snippet/css-variable-snippet.component';
import { StylingCardShellComponent } from '../styling-card-shell/styling-card-shell.component';

@Component({
    selector: 'avd-icon-color-card',
    standalone: true,
    templateUrl: './icon-color-card.component.html',
    styleUrls: ['./icon-color-card.component.scss'],
    imports: [
        StylingCardShellComponent,
        UilabMatIconModule,
        CssVariableSnippetComponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconColorCardComponent {
    @Input() cssVariable: string = '';
    @Input() label: string = '';
    @Input() inverseMode: boolean = false;

    get cssVariableName(): string {
        return this.cssVariable.trim();
    }

    get iconColor(): string {
        if (!this.cssVariableName) {
            return 'inherit';
        }

        return `var(${this.cssVariableName})`;
    }

    get cssVariableSnippet(): string {
        return this.cssVariableName;
    }
}
